import { type GivingBase, GivingTypeEnum } from 'models';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useGivingTypeOptions } from '../../../hooks';

type P = {
  giving: GivingBase;
  showZeroRaised?: boolean;
};

export const useGivingCardContent = ({ giving, showZeroRaised = false }: P) => {
  const { getTranslate } = useGivingTypeOptions();
  const { t } = useTranslation();
  const isParticipantsVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.DONATION;
  const isPriceVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.OFFERING;

  return useMemo(() => {
    const pricesProperties =
      isPriceVisible && (showZeroRaised || giving.amountTotal)
        ? {
            currentPrice: giving.amountTotal,
            label: 'Raised',
            textType: 'success' as const,
          }
        : undefined;

    return {
      description: giving.endTime ? { dateFrom: giving.startTime, dateTo: giving.endTime } : undefined,
      participantsProperties: isParticipantsVisible
        ? {
            count: giving.giversCount,
            label: (formattedMembersCount: string) =>
              t('formattedDonorsCount', { count: giving.giversCount, formattedCount: formattedMembersCount }),
          }
        : undefined,
      pricesProperties,
      progressProperties: giving.amountGoal
        ? { color: 'success' as const, max: giving.amountGoal, size: 'extra-small' as const, value: giving.amountTotal }
        : undefined,
      tagLabel: getTranslate(giving.type),
    };
  }, [
    getTranslate,
    giving.amountGoal,
    giving.amountTotal,
    giving.endTime,
    giving.giversCount,
    giving.startTime,
    giving.type,
    isParticipantsVisible,
    isPriceVisible,
    showZeroRaised,
    t,
  ]);
};
